import React, { FunctionComponent, useMemo } from "react";
import TraitsContext, { TraitsContextValue } from "contexts/TraitsContext";
import useAllTraits from "hooks/useFetchTraits";

type TraitsProviderProps = {};

const TraitsProvider: FunctionComponent<TraitsProviderProps> = ({
  children,
}) => {
  const [traits] = useAllTraits();

  const traitsMap = useMemo(
    () =>
      traits?.reduce(
        (prev, sale) => ({
          ...prev,
          [sale.tokenId]: sale,
        }),
        {}
      ),
    [traits]
  );

  const contextValue = useMemo<TraitsContextValue>(
    () => ({
      traits: traits || [],
      traitsMap: traitsMap || {},
    }),
    [traits, traitsMap]
  );

  return (
    <TraitsContext.Provider value={contextValue}>
      {children}
    </TraitsContext.Provider>
  );
};

export default TraitsProvider;
